import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        statusDraft:
          "border-transparent rounded-lg px-3 py-1 bg-[#eef2f7] text-[#5d6b82]",
        statusInProgress:
          "border-transparent rounded-lg px-3 py-1 bg-[#fef3c7] text-[#92400e]",
        statusReview:
          "border-transparent rounded-lg px-3 py-1 bg-[#dbeafe] text-[#1e40af]",
        statusApproved:
          "border-transparent rounded-lg px-3 py-1 bg-[#d1fae5] text-[#065f46]",
        statusDenied:
          "border-transparent rounded-lg px-3 py-1 bg-[#fee2e2] text-[#991b1b]",
        statusCompleted:
          "border-transparent rounded-lg px-3 py-1 bg-[#ccfbf1] text-[#115e59]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
